import type { GameWinnerResponse, UseGameWinnersLatestOptions, UseGameWinnersLatestResponse } from '@game/types'
import { useXmppListener, useApi, useQuery, useCoreConfig } from '#imports'

/**
 * Get latest game winners.
 * Gets an initial list of the latest winners and subscribes to websocket updates to update the winners list continuously.
 * @param options Options for the composable
 * @param options.limit Limit the amount of items the endpoint returns. Defaults to 11.
 */
export const useGameWinnersLatest = (options: UseGameWinnersLatestOptions = {}) => {
    const { limit = 11, enabled = true, slugs = [] } = options

    const { site } = useCoreConfig()
    const api = useApi({
        service: 'monolith',
    })

    const query = useQuery(async () => {
        const endpoint = `/combined_prizes/get_latest_winners/${limit}`
        const data = await api <Omit<UseGameWinnersLatestResponse, 'id'>>(endpoint, {
            method: 'POST',
            query: {
                brand: site.brand,
            },
            body: {
                slugs,
            },
        })

        // Add id to winners
        const latestPrizes = data.latestPrizes?.map((winner) => {
            return {
                ...winner,
            }
        })

        return latestPrizes
    }, {
        key: 'game:winners:latest',
        enabled,
        lazy: true,
        server: false,
    })

    if (import.meta.client) {
        useXmppListener<GameWinnerResponse | undefined>({ kind: 'message', xmlns: 'cego:WinnerUpdated' }, (result) => {
            if (!result) return
            query.data.value = [result, ...query.data.value?.slice(0, limit - 1) ?? []]
        })
    }

    return query
}
